{
  "uploadFile": "Ladda upp fil",
  "working": "Arbetar",
  "thinking": "Tänker",
  "newChat": "Ny chatt",
  "recentChats": "Senaste chattar",
  "recents": "Senaste",
  "chat": "Chatt",
  "files": "Filer",
  "agents": "Agenter",
  "messages_one": "{{count}} meddelande",
  "messages_other": "{{count}} meddelanden",
  "clickToRename": "Klicka för att byta namn",
  "deleteChat": "Radera chatt",
  "archive": "Arkivera",
  "unarchive": "Återställ från arkiv",
  "archived": "Arkiverade",
  "welcomeTitle": "Välkommen till Agion Assistenter",
  "welcomeSubtitle": "Starta en konversation med Agion Assistenten eller välj en specifik agent",
  "missionWelcomeTitle": "Missionschatt",
  "missionWelcomeSubtitle": "Starta en konversation med missionsteamet. Alla deltagare kan se och svara på meddelanden.",
  "agentWelcomeTitle": "Agentchatt",
  "agentWelcomeSubtitle": "Starta en konversation med denna agent. Agenten hjälper dig baserat på sina förmågor och förtroendenivå.",
  "agionAssistants": "Agion Assistenter",
  "noAgentAccess": "Ingen tillgång till agenter",
  "noAgentAccessDesc": "Du har för närvarande inte tillgång till några agenter. Kontakta din administratör.",
  "connecting": "Ansluter till realtidsuppdateringar...",
  "reconnecting": "Återansluter... (försök {{attempt}})",
  "disconnected": "Realtidsuppdateringar frånkopplade",
  "connectionError": "Anslutningsfel - försöker igen...",
  "cancelled": "Förfrågan avbruten av användaren",
  "processingError": "Tyvärr uppstod ett fel vid bearbetning av din förfrågan. Försök igen.",
  "typeToMention": "Skriv @ för att nämna filer eller agenter...",
  "referencedFiles": "Refererade filer ({{count}}):",
  "attachedFiles": "Bifogade filer ({{count}}):",
  "all": "Alla",
  "filesCount": "Filer ({{count}})",
  "agentsCount": "Agenter ({{count}})",
  "noFilesOrAgents": "Inga filer eller agenter tillgängliga",
  "uploadFilesPrompt": "Ladda upp filer eller vänta på att agenter laddas...",
  "noFilesFound": "Inga filer hittades",
  "noAgentsFound": "Inga agenter hittades",
  "sendHint": "Tryck Enter för att skicka, Shift+Enter för ny rad",
  "mentionHint": "Skriv @ för att referera filer eller agenter",
  "attachHint": "Klicka på gemet för att bifoga filer",
  "attachFile": "Bifoga fil",
  "uploadingToStorage": "Laddar upp till lagring...",
  "processing": "Bearbetar...",
  "navigateHint": "↑ ↓ för att navigera",
  "selectHint": "↵ för att välja",
  "dismissHint": "esc för att stänga",
  "you": "Du",
  "assistant": "Assistent",
  "generatedChart": "Genererat diagram",
  "signOut": "Logga ut",
  "aiAgent": "AI-agent",
  "noDescription": "Ingen beskrivning tillgänglig",
  "howCanIHelp": "Hur kan jag hjälpa dig idag?",
  "addContent": "Lägg till innehåll",
  "mentionFile": "Nämn en fil",
  "settings": "Inställningar",
  "history": "Historik",
  "autoSelect": "Automatisk",
  "noResults": "Inga resultat hittades",
  "rename": "Byt namn",
  "delete": "Radera",
  "copy": "Kopiera till urklipp",
  "copied": "Kopierat!",
  "regenerate": "Generera om",
  "processedIn": "Bearbetat på {{time}}s",
  "maxFilesReached": "Maximalt {{max}} filer tillåtna",
  "chats": "Chattar",
  "tasks": "uppgifter",
  "tasksCount": "{{count}} uppgifter",
  "searchChats": "Sök chattar...",
  "noChatsFound": "Inga chattar hittades",
  "participants": "deltagare",
  "external": "extern",
  "showingAs": "Visas som",
  "internalNote": "Intern anteckning",
  "internal": "Anteckning",
  "reply": "Svara",
  "replyToCustomer": "Svara kunden",
  "missionAccessDenied": "Du har inte tillgång till detta uppdrag. Du kan ha blivit borttagen som deltagare.",
  "missionAccessDeniedMessage": "Åtkomst nekad. Du är inte deltagare i detta uppdrag.",
  "voiceInput": "Röstinmatning",
  "stopRecording": "Stoppa inspelning",
  "recording": "Spelar in...",
  "transcribing": "Transkriberar...",
  "microphoneAccessDenied": "Mikrofonåtkomst nekad",
  "recordingFailed": "Inspelning misslyckades",
  "disclaimer": "Agenter kan göra misstag. Verifiera alltid resultaten.",
  "failedToGetResponse": "Kunde inte få svar",
  "downloadChart": "Ladda ner diagram",
  "freePlan": "Gratis plan",
  "unknownMission": "Okänt uppdrag",
  "unnamedMission": "Namnlöst uppdrag",
  "missions": "Uppdrag",
  "noMissions": "Inga uppdrag tillgängliga",
  "createMissionInAdmin": "Skapa ett uppdrag i adminpanelen",
  "newMission": "Nytt uppdrag",
  "awaitingHumanInput": "Väntar på mänsklig inmatning",
  "open": "Öppna",
  "attention": "Uppmärksamhet",
  "running": "Pågår",
  "recent": "Senaste",
  "showHosts": "Visa värdar",
  "hideHosts": "Dölj värdar",
  "timeAgo": {
    "justNow": "just nu",
    "minutesAgo": "{{count}}m sedan",
    "hoursAgo": "{{count}}h sedan",
    "daysAgo": "{{count}}d sedan"
  },
  "recentRuns": {
    "showAll": "Visa alla konversationer",
    "showMore": "Visa fler konversationer",
    "showFewer": "Visa färre",
    "loading": "Laddar konversationer…",
    "loadError": "Tidigare konversationer kunde inte läsas in"
  },
  "missionRunning": "Uppdrag pågår",
  "searchMissions": "Sök uppdrag...",
  "noMatchingMissions": "Inga matchande uppdrag",
  "drafts": "Utkast",
  "hostOnline": "Server online",
  "hostOffline": "Server offline",
  "hostStatusChecking": "Kontrollerar serverstatus...",
  "hostStatusUnknown": "Serverstatus okänd",
  "hosts": "Servrar",
  "noHosts": "Inga servrar tillgängliga",
  "unassigned": "Ej tilldelade",
  "hostGroup": "Värdgrupp",
  "selectMission": "Välj ett uppdrag",
  "selectMissionDescription": "Välj ett uppdrag från sidofältet för att börja chatta med din agent.",
  "clickNewChatToStart": "Klicka på \"Ny chatt\" för att börja",
  "landing": {
    "title": "Vad vill du arbeta med?",
    "subtitle": "Välj hur du vill komma igång",
    "missionChat": "Uppdragschatt",
    "missionChatDescription": "Kör ett uppdrag och interagera med det via chatt",
    "knowledgeBase": "Kunskapsbas",
    "knowledgeBaseDescription": "Ställ frågor om din organisations kunskap",
    "chatWithData": "Chatta med data",
    "chatWithDataDescription": "Fråga dina anslutna datakällor via konversation",
    "selectAMission": "Välj ett uppdrag för att börja",
    "noActiveMissions": "Inga aktiva uppdrag tillgängliga",
    "startChat": "Starta chatt",
    "autostart": "Uppdraget startar automatiskt",
    "searchMissions": "Sök uppdrag...",
    "recentlyUpdatedMissions": "Nyligen uppdaterade uppdrag",
    "missionListSubtitle": "Dina uppdrag",
    "orStartNew": "eller starta en ny konversation",
    "greeting": "Vad vill du göra?",
    "inputPlaceholder": "Beskriv vad du behöver eller släpp en fil...",
    "hint": "Skriv ett meddelande eller släpp en fil, välj sedan ett uppdrag",
    "removeFile": "Ta bort fil",
    "loadError": "Dina uppdrag kunde inte läsas in",
    "noMissionsGuest": "Inga uppdrag har delats med dig ännu. Be personen som bjöd in dig att lägga till dig i ett.",
    "noMissionsGuestWithInviter": "Inga uppdrag har delats med dig ännu. När någon delar ett visas det här — be {{inviter}} att lägga till dig i ett.",
    "noMissionsReader": "Uppdrag som du läggs till i visas här.",
    "guestOrgContext": "Du är i {{org}}.",
    "guestOrgContextWithInviter": "Du är i {{org}}, inbjuden av {{inviter}}.",
    "guestCapabilities": "Som gäst kan du öppna och köra de uppdrag som delas med dig. Du kan inte skapa uppdrag eller bjuda in andra personer.",
    "guestHintBody": "Som gäst kan du öppna och köra uppdrag som {{inviter}} har delat med dig. Nya visas här automatiskt.",
    "guestHintBodyNoInviter": "Som gäst kan du öppna och köra uppdrag som delats med dig. Nya visas här automatiskt.",
    "guestHintDismiss": "Avvisa",
    "draft": "Utkast"
  },
  "welcome": {
    "greeting": "Hur kan jag hjälpa dig idag?",
    "subtitle": "Starta en konversation eller välj ett förslag nedan",
    "noMissionsSubtitle": "Inga aktiva uppdrag ännu. Starta en konversation eller skapa ett uppdrag.",
    "startConversation": "Starta en ny konversation",
    "missionSubtitle": "Skicka ett meddelande för att börja detta uppdrag",
    "agentsInMission": "Agenter:",
    "startMission": "Starta uppdraget",
    "suggestions": {
      "summarize": "Sammanfatta senaste uppdragsresultat",
      "agents": "Vilka agenter finns tillgängliga?",
      "mission": "Hjälp mig skapa ett nytt uppdrag",
      "governance": "Förklara ett styrningsbeslut"
    },
    "agentSuggestions": {
      "intro": "Berätta om dig själv",
      "help": "Vad kan du hjälpa mig med?"
    }
  },
  "modes": {
    "mission": "Mission",
    "kb": "Kunskapsbas",
    "data": "Data"
  },
  "conversationHistory": {
    "title": "Konversationer",
    "noConversations": "Inga konversationer ännu",
    "startNew": "Starta en ny konversation ovan"
  },
  "trigger": {
    "childMissionLaunched": "Ett nytt uppdrag startades",
    "continueWith": "Fortsätt med {{name}}?",
    "openMission": "Öppna uppdrag",
    "missionTriggered": "Uppdrag utlöst"
  },
  "customer": {
    "historyLoadFailed": "Konversationen kunde inte läsas in från Edge-värden.",
    "historyLoadFailedHint": "Körningen kan ha sagt mer än vad som visas här. Försök igen om en stund.",
    "historyHostUnknown": "Edge-värden som körde det här uppdraget har inte registrerats, så dess konversation kan inte hittas.",
    "progress": {
      "title": "Förlopp",
      "stepsCompleted": "{{completed}} av {{total}} steg",
      "allComplete": "Alla steg slutförda",
      "failed": "Körning misslyckades"
    },
    "missionCompleted": "Uppdraget slutfördes",
    "missionStopped": "Körningen stoppades",
    "missionFailed": "Något gick fel. Försök igen eller kontakta support.",
    "missionAnswerTimeout": "Körningen avslutades eftersom inget svar kom i tid. Skicka ett meddelande för att starta en ny körning.",
    "missionToolReportedError": "Verktyget kunde inte använda den här indatan: {{reason}}. Kontrollera indatan och försök igen.",
    "missionCriteriaNotMet": "Körningen slutfördes, men den uppfyllde inte alla sina framgångskriterier. Kontrollera svaret innan du förlitar dig på det.",
    "missionNoResourceEvidence": "Körningen kunde inte hämta några uppgifter från de anslutna systemen, så svaret kan vara ofullständigt. Be din administratör kontrollera anslutningen innan du förlitar dig på svaret.",
    "questionExpired": "Denna fråga har upphört",
    "reconnecting": "Återansluter...",
    "streamingUnavailable": "Realtidsuppdateringar är tillfälligt otillgängliga. Du kan fortfarande bläddra i konversationshistoriken.",
    "typeMessage": "Skriv ett meddelande...",
    "typeToRestart": "Skriv ett meddelande för att starta en ny körning...",
    "newRunDivider": "Ny körning startad. Tidigare meddelanden visas som referens.",
    "respondToQuestion": "Skriv ditt svar...",
    "waitingForMission": "Väntar på missionssvar...",
    "stop": "Stoppa",
    "stopMission": "Stoppa uppdraget",
    "pause": "Pausa",
    "pauseMission": "Pausa uppdraget",
    "resume": "Återuppta",
    "resumeMission": "Återuppta uppdraget",
    "historyHostOfflineNamed": "{{name}}, Edge-värden som har den här konversationen, är offline. Försök igen när den är tillbaka.",
    "historyHostOffline": "Edge-värden som har den här konversationen är offline. Försök igen när den är tillbaka.",
    "runHostMoved": "Den här körningen startade på en annan Edge-värd eftersom den som har den tidigare konversationen inte är tillgänglig. Filer från tidigare meddelanden är inte tillgängliga för den här körningen.",
    "conversationOwnedByOther": "Den här konversationen tillhör en annan person. Bara den personen kan läsa den här.",
    "conversationStartedAutomatically": "Den här konversationen startades av ett schema eller en utlösare, inte av en person. Innehållet kan bara öppnas från granskningssidan."
  },
  "kb": {
    "title": "Kunskapsbas",
    "placeholder": "Ställ en fråga...",
    "thinking": "Söker i kunskapsbasen...",
    "noSources": "Inga källor hittades",
    "sources": "Källor",
    "fromOrg": "Organisation",
    "fromMission": "Mission",
    "askFollowUp": "Ställ en uppföljningsfråga..."
  },
  "data": {
    "title": "Chatta med data",
    "selectResources": "Välj datakällor",
    "selectSources": "Välj datakällor att fråga",
    "noResources": "Inga datakällor tillgängliga",
    "noSources": "Inga datakällor tillgängliga",
    "sourcesSelected": "källor valda",
    "askPrompt": "Ställ en fråga om dina datakällor",
    "selected": "valda",
    "startChat": "Starta chatt",
    "placeholder": "Fråga om din data...",
    "querying": "Frågar datakällor..."
  },
  "governance": {
    "prefix": "Styrning",
    "allowed": "Styrning: Tillåtet",
    "denied": "Nekat",
    "obfuscated": "Fördunklat",
    "escalated": "Eskalerat"
  },
  "trust": {
    "tooltip": {
      "tier0": "Begränsad — Agenten arbetar under maximal övervakning. Alla åtgärder kräver godkännande.",
      "tier1": "Delvis begränsad — Agenten kan utföra grundläggande uppgifter men stannar vid viktiga beslut.",
      "tier2": "Standard — Agenten hanterar rutinarbete och stannar vid viktiga beslut.",
      "tier3": "Utökad — Agenten har utökade behörigheter och agerar med minimala pauser."
    }
  },
  "executionLog": {
    "title": "Aktivitet",
    "openPanel": "Öppna aktivitet",
    "closePanel": "Stäng aktivitet",
    "waitingForEvents": "Väntar på händelser...",
    "noEventsYet": "Inga händelser ännu",
    "contentOnHost": "Innehållet lagras på Edge-värden",
    "mission": "Uppdrag",
    "rankingDegraded": "Rankning försämrad",
    "noConfidentMatch": "Ingen säker träff",
    "warningCount": "{{count}} varning",
    "warningCount_other": "{{count}} varningar",
    "forced": {
      "label": "Avslutades i förtid",
      "budget": "Avslutades i förtid: omgångarna tog slut. Resultatet kan vara ofullständigt. Begränsa vad steget ber om, eller dela upp det.",
      "stuckRepeating": "Avslutades i förtid: upprepade samma anrop. Resultatet kan vara ofullständigt. Ändra stegets instruktioner.",
      "repeatedFailure": "Avslutades i förtid efter upprepade verktygsfel. Resultatet kan vara ofullständigt. Kontrollera anslutningen som steget använder.",
      "schemaChurn": "Avslutades i förtid: källdatans struktur ändrades hela tiden. Resultatet kan vara ofullständigt. Kontrollera källans schema."
    }
  },
  "missionChat": {
    "editInDesigner": "Redigera i designern"
  },
  "workflow": {
    "status": "Arbetsflöde: {{status}}",
    "pause": "Pausa",
    "resume": "Återuppta",
    "cancel": "Avbryt",
    "approve": "Godkänn",
    "reject": "Avvisa",
    "progress": "{{completed}} av {{total}} steg slutförda",
    "currentStep": "Kör: {{step}}{{agent}}",
    "turn": "Omgång {{current}}/{{max}}",
    "turnProgress": "Omgång {{current}} av {{max}}",
    "duration": "Varaktighet: {{duration}}",
    "waitingApproval": "{{count}} steg väntar på godkännande",
    "noSteps": "Inga arbetsflödessteg definierade",
    "dependsOn": "Beror på",
    "viewDetails": "Visa arbetsflödesdetaljer",
    "event": {
      "started": "Arbetsflöde startat",
      "startedDescription": "Kör {{steps}} steg",
      "paused": "Arbetsflöde pausat",
      "pausedDescription": "Arbetsflödet har pausats",
      "resumed": "Arbetsflöde återupptagits",
      "resumedDescription": "Arbetsflödeskörning återupptagen",
      "completed": "Arbetsflöde slutfört",
      "completedDescription": "Slutförde {{steps}} steg på {{duration}}",
      "failed": "Arbetsflöde misslyckades",
      "cancelled": "Arbetsflöde avbrutet",
      "cancelledDescription": "Arbetsflödeskörningen avbröts",
      "stepStarted": "Steg startat: {{step}}",
      "stepStartedAgent": "Agent {{agent}} kör",
      "stepStartedDescription": "Stegkörning startad",
      "stepProgress": "Stegförlopp: {{step}}",
      "stepProgressDescription": "Omgång {{current}} av {{max}}",
      "stepCompleted": "Steg slutfört: {{step}}",
      "stepCompletedDescription": "Slutfördes på {{duration}}",
      "stepFailed": "Steg misslyckades: {{step}}",
      "stepWaitingApproval": "Godkännande krävs: {{step}}",
      "unknown": "Arbetsflödeshändelse"
    },
    "command": {
      "statusHelp": "Visa arbetsflödesstatus",
      "pauseHelp": "Pausa pågående arbetsflöde",
      "resumeHelp": "Återuppta pausat arbetsflöde",
      "cancelHelp": "Avbryt pågående arbetsflöde",
      "approveHelp": "Godkänn väntande steg",
      "rejectHelp": "Avvisa väntande steg"
    }
  },
  "outputFile": {
    "download": "Ladda ner",
    "downloading": "Laddar ner…",
    "downloadFailed": "Nedladdningen misslyckades. Försök igen.",
    "noHost": "Filer från den här assistenten kan inte laddas ner här ännu.",
    "noLongerAvailable": "Filen är inte längre tillgänglig. Be assistenten att skapa den igen.",
    "noAccess": "Du har inte tillgång till den här filen.",
    "hostOffline": "Servern där filen finns är offline. Försök igen när den är ansluten."
  },
  "delivery": {
    "waiting": "Väntar på att filerna laddas upp…",
    "sending": "Skickar…",
    "queued": "I kö: assistenten läser det när det pågående steget är klart.",
    "delivered": "Levererat",
    "notConnected": "Inte skickat: anslutningen till assistenten är nere.",
    "noReceipt": "Inte bekräftat: inget kvitto kom, så assistenten kanske inte har fått det.",
    "notStarted": "Inte skickat: konversationen kunde inte starta.",
    "notAccepted": "Servern bekräftade inte meddelandet. Försök igen. Om det fortsätter att misslyckas kan servern vara offline eller behöva uppdateras.",
    "undelivered": "Inte levererat: körningen avslutades innan assistenten läste det.",
    "unconfirmed": "Leveransen är inte bekräftad: värden kunde inte bekräfta att den fick det här svaret.",
    "refused": "Inte levererat.",
    "backInComposer": "Det finns i meddelanderutan igen så att du kan skicka det på nytt.",
    "chooseAgain": "Välj ditt svar igen."
  },
  "receiptReason": {
    "invalidMessage": "Meddelandet kunde inte läsas.",
    "notSubscribed": "Den här chatten följer inte längre körningen. Ladda om sidan och försök igen.",
    "senderNotAllowed": "Bara den som startade körningen kan skicka meddelanden till den.",
    "runNotLive": "Körningen pågår inte längre.",
    "hostNotConnected": "Värden som kör assistenten är inte ansluten.",
    "runnerNotConnected": "Värden som kör assistenten är ansluten, men inte dess körmotor.",
    "messageTooLarge": "Meddelandet är för stort för att skickas.",
    "channelFull": "Anslutningen till assistenten är upptagen. Försök igen om en stund.",
    "inboxFull": "Assistenten har redan flera meddelanden som väntar. Skicka det här när den har läst dem.",
    "modeDoesNotAccept": "Den här körningen tar inte emot meddelanden medan den arbetar.",
    "duplicate": "Assistenten har redan det här meddelandet.",
    "unknownMessageType": "Servern kände inte igen meddelandet; den kan behöva uppdateras.",
    "runEndedBeforeDelivery": "Körningen avslutades innan assistenten läste det.",
    "attachmentInvalid": "De bifogade filerna kunde inte verifieras. Ta bort dem och bifoga dem igen.",
    "attachmentHostMismatch": "Filerna laddades upp till en annan server. Bifoga dem på servern för den här körningen.",
    "attachmentHostAmbiguous": "Servern som har filerna kunde inte verifieras. Bifoga filerna igen.",
    "attachmentTooMany": "Meddelandet har för många filer. Ta bort några filer och försök igen.",
    "attachmentUnavailable": "De bifogade filerna är inte tillgängliga. Försök igen eller ta bort bilagorna och bifoga filerna på nytt."
  },
  "questionAnswerReason": {
    "answerInProgress": "Ett annat svar på frågan kontrolleras fortfarande. Vänta en stund och försök igen.",
    "answerAdmissionUnavailable": "Värden kunde inte ta emot svaret i tid. Försök igen.",
    "invalidAnswer": "Svaret kunde inte läsas. Kontrollera det och försök igen.",
    "attemptConflict": "Svaret skiljer sig från det tidigare utskick det upprepar. Skicka det igen.",
    "questionClosed": "Den här frågan är inte längre öppen.",
    "confirmationUnavailable": "Värden kan inte längre bekräfta om den fick det här svaret.",
    "senderNotAllowed": "Du får inte svara på den här frågan.",
    "runNotLive": "Körningen pågår inte längre.",
    "attachmentInvalid": "De bifogade filerna kunde inte verifieras. Ta bort dem och bifoga dem igen.",
    "attachmentHostMismatch": "Filerna laddades upp till en annan server. Bifoga dem på servern för den här körningen.",
    "attachmentHostAmbiguous": "Servern som har filerna kunde inte verifieras. Bifoga filerna igen.",
    "attachmentTooMany": "Svaret har för många filer. Ta bort några filer och försök igen.",
    "attachmentUnavailable": "De bifogade filerna är inte tillgängliga. Försök igen eller ta bort bilagorna och bifoga filerna på nytt."
  },
  "questionClosed": {
    "cancelled": "Den här frågan drogs tillbaka.",
    "expired": "Tiden för att svara på den här frågan har gått ut.",
    "publicationFailed": "Den här frågan kunde inte visas, så den stängdes.",
    "executionEnded": "Den här frågan stängdes när körningen avslutades."
  },
  "composer": {
    "agentWorking": "Assistenten arbetar. Du kan svara när den ställer en fråga till dig.",
    "chooseAnOption": "Svara genom att välja ett av alternativen ovan.",
    "questionClosed": "Den här frågan är inte längre öppen.",
    "attachUnavailable": "Den här assistenten kan inte ta emot filer.",
    "attachFindingHost": "Letar efter servern som tar emot dina filer…",
    "attachGroupOffline": "Ingen av servrarna som den här assistenten körs på är online, så den kan inte ta emot filer just nu. Försök igen när någon är tillbaka.",
    "attachHostNotFound": "Servern som skulle ta emot dina filer hittades inte. Läs in sidan igen för att försöka på nytt.",
    "fileNotUploaded": "En fil laddades inte upp. Försök igen eller ta bort den och skicka sedan.",
    "launchFailed": "Konversationen kunde inte starta.",
    "tooLong": "Meddelandet är för långt för att skickas. Korta ner det.",
    "pasteTooLong": "Det inklistrade skulle göra meddelandet för långt att skicka, så det lades inte till.",
    "notReadyTool": "Den här assistenten kan inte starta ännu eftersom ett verktyg den använder inte är klart. Be dess ägare att slutföra det.",
    "notReadySetup": "Den här assistenten kan inte starta ännu eftersom dess inställningar inte är klara. Be dess ägare att slutföra dem."
  },
  "launchRefusal": {
    "defaultModelMissing": {
      "admin": "Din organisation har ingen standardchattmodell, så uppdraget har ingen agent att köras som. Välj en i administrationskonsolen under Styrning > Resurser > Modeller.",
      "member": "Din organisation har ingen standardchattmodell, så uppdraget har ingen agent att köras som. Be en administratör att välja en."
    },
    "openModelSettings": "Öppna modellinställningar",
    "grantAccessNotReady": {
      "named": "Körningen startade inte eftersom uppdragets agentåtkomst till följande resurser inte är på plats än: {{resources}}. Försök igen om en stund. Om problemet kvarstår, kontakta support@agion.ai.",
      "unnamed": "Körningen startade inte eftersom uppdragets agentåtkomst inte är på plats än. Försök igen om en stund. Om problemet kvarstår, kontakta support@agion.ai."
    },
    "grantAdminDenied": {
      "named": "Körningen startade inte eftersom en administratör har tagit bort agentens åtkomst till följande resurser: {{resources}}. Fråga din administratör eller kontakta support@agion.ai.",
      "unnamed": "Körningen startade inte eftersom en administratör har tagit bort agentens åtkomst till en resurs som uppdraget använder. Fråga din administratör eller kontakta support@agion.ai."
    },
    "grantTrustTierTooLow": {
      "named": "Körningen startade inte eftersom agentens förtroendenivå inte tillåter det som uppdraget behöver för följande resurser: {{resources}}. Fråga din administratör eller kontakta support@agion.ai.",
      "unnamed": "Körningen startade inte eftersom agentens förtroendenivå inte tillåter det som uppdraget behöver för en resurs som uppdraget använder. Fråga din administratör eller kontakta support@agion.ai."
    }
  },
  "escalations": {
    "title": "Eskaleringar",
    "fallbackTitle": "Eskalering",
    "approve": "Godkänn",
    "deny": "Neka",
    "reasonPlaceholder": "Motivering (valfritt)",
    "confirmApprove": "Bekräfta godkännande",
    "confirmDeny": "Bekräfta nekande",
    "cancel": "Avbryt",
    "resolving": "Skickar…",
    "expired": "Utgången",
    "expiredNote": "Kan inte längre hanteras — steget gick ut innan ett beslut fattades.",
    "missionLabel": "Uppdrag",
    "actionLabel": "Vill köra",
    "ruleLabel": "Regel",
    "traceToggle": "Policydetaljer",
    "consequence": "Godkänn kör steget nu · Neka blockerar det",
    "type": {
      "actionApproval": "Godkännande krävs",
      "chatHandoff": "Överlämning begärd",
      "contentReview": "Innehållsgranskning",
      "guidance": "Vägledning begärd",
      "complianceReview": "Efterlevnadsgranskning",
      "question": "Fråga"
    },
    "question": {
      "answerPlaceholder": "Ditt svar",
      "submit": "Skicka svar",
      "answerLabel": "Svar",
      "answeredByLabel": "Besvarad av",
      "answeredAtLabel": "Besvarad",
      "answerKeptWithRun": "Svaret sparas hos körningen.",
      "unavailable": "Frågan kan inte visas.",
      "error": {
        "invalid": "Frågan godtar inte det här svaret.",
        "expired": "Frågan gick ut innan svaret kom fram.",
        "alreadyAnswered": "Någon annan besvarade frågan först.",
        "forbidden": "Du kan inte besvara den här frågan.",
        "failed": "Svaret skickades inte. Försök igen.",
        "ticketMismatch": "Svaret stämde inte med din session. Ladda om sidan och försök igen.",
        "ticketExpired": "Det tog för lång tid att skicka svaret. Försök igen.",
        "runNotLive": "Körningen har avslutats, så den kan inte ta emot svaret.",
        "hostNotConnected": "Värden som kör det här uppdraget är inte ansluten. Försök igen senare.",
        "malformed": "Svaret kunde inte läsas. Försök igen.",
        "unreachable": "Det gick inte att nå körningen. Försök igen.",
        "unconfirmed": "Körningen har svaret, men det är inte registrerat än. Kontrollera igen om en stund."
      },
      "form": {
        "required": "Obligatoriskt",
        "submitNone": "Jag kunde inte fastställa något av dessa",
        "answeredFields": "Besvarade fält",
        "noneAnswered": "Inget fält kunde fastställas.",
        "error": {
          "number": "Ange ett tal.",
          "date": "Ange ett fullständigt datum."
        }
      }
    },
    "evidence": {
      "open": "Öppna underlaget",
      "hide": "Dölj underlaget",
      "opening": "Öppnar…",
      "label": "Underlag",
      "task": "Uppgift",
      "context": "Sammanhang",
      "constraints": "Begränsningar",
      "error": {
        "unavailable": "Underlaget kan inte öppnas.",
        "tooLarge": "Underlaget är för stort för att öppnas här.",
        "failed": "Underlaget öppnades inte. Försök igen."
      }
    },
    "questionCard": {
      "waiting": "En fråga väntar på någon som kan avgöra den.",
      "answered": "Besvarad",
      "askedBy": "Frågas av",
      "evidenceTitle": "Vad specialisten såg",
      "evidenceUnavailable": "Underlaget kan inte visas här.",
      "evidenceEmpty": "Specialisten fick inga uppgifter."
    },
    "header": {
      "questionWaiting": "En fråga väntar",
      "unknownMission": "Ett uppdrag",
      "answerInEscalations": "Svara i Eskaleringar"
    },
    "reviewReason": {
      "decisionCouldNotChoose": "Beslutsmodellen kunde inte välja.",
      "decisionUnavailable": "Beslutsmodellen var inte tillgänglig.",
      "agentUnsure": "Specialistens modell var inte säker.",
      "agentUnavailable": "Specialistens modell var inte tillgänglig.",
      "agentModelSkipped": "Uppdraget frågar en person direkt när beslutsmodellen inte kan välja."
    }
  },
  "operatorTakeover": {
    "personMarker": "Person",
    "takeOver": "Ta över",
    "takingOver": "Tar över…",
    "heldByYou": "Du håller i det här samtalet.",
    "openConversation": "Öppna samtalet",
    "banner": "Du svarar kunden som dig själv",
    "holdUntil": "Du håller i samtalet till {{time}}.",
    "ended": "Du håller inte längre i det här samtalet.",
    "notHeld": "Du håller inte i det här samtalet.",
    "earlierRunsIncomplete": "En del av det tidigare samtalet kunde inte läsas in.",
    "placeholder": "Skriv till kunden",
    "send": "Skicka",
    "handBack": "Lämna tillbaka",
    "handingBack": "Lämnar tillbaka…",
    "handBackFailed": "Samtalet lämnades inte tillbaka. Försök igen.",
    "reply": {
      "sending": "Skickar…",
      "accepted": "Levererat till kunden",
      "notSent": "Inte skickat: anslutningen är nere.",
      "refused": "Avvisat"
    },
    "refusal": {
      "expired": "Begäran gick ut innan du tog över.",
      "self": "Du startade samtalet själv, så någon annan måste ta över det.",
      "notPending": "Någon annan tog över samtalet, eller så har det avslutats.",
      "forbidden": "Du kan inte ta över det här samtalet.",
      "failed": "Samtalet togs inte över. Försök igen."
    },
    "replyRefusal": {
      "malformed": "Svaret kunde inte läsas. Kontrollera texten och skicka igen.",
      "senderNotAllowed": "Logga in igen för att svara.",
      "notSubscribed": "Samtalet är inte öppet här. Ladda om det och svara igen.",
      "disabled": "Att ta över samtal är avstängt.",
      "noHold": "Du håller inte längre i det här samtalet.",
      "notOperator": "En annan person håller i det här samtalet.",
      "unavailable": "Samtalet gick inte att nå. Försök igen.",
      "other": "Svaret avvisades."
    }
  },
  "notifications": {
    "hitlTitle": "Uppdraget väntar på ditt svar",
    "governanceTitle": "Styrningsvarning",
    "escalationTitle": "Eskalering väntar på beslut"
  },
  "delegation": {
    "blocked": {
      "label": "Blockerad av inställningarna",
      "message": "{{agent}} kunde inte slutföra uppgiften: {{reason}}.",
      "targetNotBound": "systemet är inte anslutet till det här uppdraget",
      "targetNotAuthorized": "det här uppdraget har inte behörighet att använda systemet",
      "operationOutsideScope": "åtgärden är inte tillåten i det här uppdraget",
      "credentialUnavailable": "anslutningen saknar användbara autentiseringsuppgifter",
      "other": "uppdragets inställningar tillåter inte den här begäran",
      "hint": "Den som skapat uppdraget eller en administratör kan ändra detta."
    }
  },
  "launchInputs": {
    "title": "Startvärden",
    "hint": "Körningen startar med de här värdena.",
    "enterValue": "Ange ett värde för att starta körningen.",
    "invalidJson": "Ange giltig JSON, till exempel {\"key\": \"value\"} eller [1, 2].",
    "invalidNumber": "Ange ett tal.",
    "invalidInteger": "Ange ett heltal.",
    "invalidBoolean": "Ange true eller false.",
    "selectFile": "Välj en uppladdad fil",
    "uploadFile": "Ladda upp en fil",
    "uploadingFile": "Laddar upp fil…",
    "uploadFailed": "Filuppladdningen misslyckades.",
    "retryUpload": "Försök ladda upp igen",
    "removeFile": "Ta bort fil",
    "completeFile": "Välj en fil vars uppladdning är klar.",
    "nextMessageStartsRun": "Ditt nästa meddelande startar en ny körning.",
    "changeValues": "Ändra startvärden",
    "hideValues": "Dölj startvärden",
    "startValuePlaceholder": "Skriv ett värde och tryck på Enter för att starta en ny körning."
  },
  "nextSections": {
    "attention": {
      "title": "Väntar på ditt svar",
      "awaitingInput": "Väntar på din inmatning",
      "policyDecision": "Policybeslut",
      "escalate": "Eskalera"
    },
    "recent": {
      "loadError": "Senaste konversationerna kunde inte läsas in",
      "nameNotLoaded": "Uppdragets namn har inte lästs in",
      "outcome": {
        "running": "Pågår",
        "completed": "Klar",
        "failed": "Misslyckades",
        "cancelled": "Stoppad"
      }
    }
  },
  "nextConversation": {
    "agent": "Agent",
    "copy": "Kopiera",
    "helpful": "Hjälpsamt",
    "notHelpful": "Inte hjälpsamt",
    "attach": "Bifoga filer",
    "voice": "Röstinmatning",
    "send": "Skicka meddelande",
    "hint": "Retur skickar · Skift+Retur för ny rad",
    "working": "Uppdraget pågår",
    "governance": {
      "deny": "Nekad",
      "obfuscate": "Maskerad",
      "escalate": "Eskalerad",
      "audit": "Loggad"
    },
    "historyLoadError": "Den här konversationen kunde inte läsas in från Edge-värden",
    "question": {
      "closed": "Den här frågan är inte längre öppen.",
      "submit": "Skicka svar",
      "atLeast_one": "Välj minst {{count}} alternativ.",
      "atLeast_other": "Välj minst {{count}} alternativ.",
      "otherLabel": "Annat",
      "otherPlaceholder": "Skriv ditt svar"
    },
    "escalation": {
      "approve": "Godkänn",
      "deny": "Neka",
      "approveConsequence": "När du godkänner fortsätter {{agent}} sin körning och utför den begärda åtgärden.",
      "denyConsequence": "När du nekar utför {{agent}} inte åtgärden, och steget i körningen som bad om den misslyckas.",
      "reasonLabel": "Orsak",
      "reasonPlaceholder": "Orsak...",
      "reasonRequired": "En orsak krävs.",
      "confirmApprove": "Bekräfta godkännande",
      "confirmDeny": "Bekräfta nekande",
      "cancel": "Avbryt",
      "backToRequest": "Tillbaka"
    }
  },
  "nextActivity": {
    "turn": "Tur",
    "thinking": "Tänker",
    "started": "Startad",
    "completed": "Slutförd",
    "failed": "Misslyckad",
    "succeeded": "Lyckades",
    "waiting": "väntar...",
    "humanInput": "Mänsklig inmatning",
    "humanResponse": "Mänskligt svar",
    "orchestrator": "Orkestrerare",
    "delegatedTo": "Delegerat till",
    "error": "Fel",
    "terminalFailure": "Avslutande fel",
    "thinkingRedactedBody": "Modellens interna resonemang har dolts.",
    "model": "Modell",
    "tokens": "Token",
    "duration": "Varaktighet",
    "depth": "Djup",
    "in": "i",
    "out": "ut",
    "filterAll": "Alla",
    "filterTurns": "Turer",
    "filterTools": "Verktyg",
    "filterHitl": "HITL",
    "expand": "Visa mer",
    "collapse": "Visa mindre",
    "statusRunning": "Uppdraget körs",
    "statusComplete": "Körningen klar",
    "statusPaused": "Pausad",
    "statusFailed": "Körningen misslyckades",
    "steps": "Steg",
    "costLive": "Kostnad hittills",
    "costEstimate": "Uppsk. kostnad",
    "costUnknown": "Okänd",
    "usageNotReported_one": "{{count}} anrop, användningen rapporterades inte",
    "usageNotReported_other": "{{count}} anrop, användningen rapporterades inte",
    "costExcludesUnreported_one": "Exklusive {{count}} anrop utan rapporterad användning",
    "costExcludesUnreported_other": "Exklusive {{count}} anrop utan rapporterad användning",
    "checkingModelUse": "Kontrollerar modellanvändningen…",
    "tokenSpend": "Tokenförbrukning",
    "awaitingFirstCall": "Väntar på första modellanropet",
    "executionLog": "Körningslogg",
    "jumpToLatest": "Hoppa till senaste",
    "showBreakdown": "Visa uppdelning per modell",
    "hideBreakdown": "Dölj uppdelning per modell",
    "unnamedStep": "Namnlöst steg",
    "runEnding": {
      "tool_result_too_large": "Ett verktyg returnerade för mycket data",
      "host_disconnected": "Värden tappade anslutningen",
      "idle_timeout": "Körningen slutade svara",
      "context_window_exhausted": "Konversationen blev för lång för modellen",
      "llm_deadline": "Modellen svarade inte i tid",
      "mission_budget_exceeded": "Körningen förbrukade sin budget",
      "provider_unavailable": "Modelleverantören var överbelastad eller nere",
      "provider_quota_exhausted": "Modelleverantörens kvot är förbrukad",
      "model_tool_format_rejected": "Modellen kunde inte använda uppdragets verktyg",
      "repeated_gate_rejection": "Körningen föll upprepade gånger på samma slutkontroll",
      "criteria_not_met": "Svaret uppfyllde inte alla framgångskriterier",
      "no_successful_resource_evidence": "Inga uppgifter kom från de anslutna systemen",
      "timeout": "Ett anrop tog för lång tid",
      "permission_denied": "Åtkomst nekades",
      "not_found": "Något hittades inte",
      "rate_limited": "För många förfrågningar",
      "network_error": "Ett system kunde inte nås",
      "service_unavailable": "Ett system var inte tillgängligt",
      "validation_error": "En begäran avvisades som ogiltig",
      "token_limit": "Modellens längdgräns nåddes",
      "internal_error": "Ett oväntat fel",
      "schema_error": "Ett svar hade en oväntad form",
      "model_output_unfit": "Modellen gav upprepade gånger svar som inte kunde visas",
      "transport_error": "Körningens meddelanden kunde inte föras vidare",
      "tool_blocked": "Agion blockerade anropet"
    },
    "statusStarting": "Startar",
    "statusDone": "Klar",
    "waitingForAnswer": "Väntar på ditt svar",
    "noModelUse": "Ingen modellanvändning registrerad för den här körningen",
    "questionStep": "Fråga",
    "messageToYou": "Meddelande till dig",
    "answerStep": "Svar",
    "agentStep": "Agent",
    "runStep": "Körning",
    "stepId": "Stegets id",
    "filterQuestions": "Frågor"
  },
  "header": {
    "search": "Sök meddelanden",
    "closeSearch": "Stäng sökning",
    "metaStarted": "Startad {{time}}",
    "metaTrust": "Förtroende: {{tier}}",
    "metaRuns": "{{count}} körningar",
    "allRuns": "Alla körningar",
    "moreActions": "Fler åtgärder"
  },
  "nextRunStep": {
    "running": "Körs",
    "waiting": "Körs inte",
    "completed": "Klar",
    "warning": "Klar med en varning",
    "failed": "Misslyckades",
    "moreTools_one": "+{{count}} till",
    "moreTools_other": "+{{count}} till",
    "unnamedStep": "Namnlöst steg"
  },
  "runEnd": {
    "endedWithCause": "Körningen avslutades: {{cause}}.",
    "missing": "Saknas: {{items}}.",
    "failed": "Körningen misslyckades.",
    "cause": {
      "agent": "agenten kunde inte slutföra arbetet",
      "person": "den väntade på en person",
      "environment": "ett anslutet system eller en tjänst fungerade inte som det behövdes",
      "platform": "plattformen hade ett problem",
      "missionDesign": "uppdragets inställningar eller gränser stoppade den",
      "unknown": "orsaken registrerades inte",
      "noAnswer": "ingen svarade i tid"
    },
    "next": {
      "agent": "Gör uppgiften tydligare och kör den sedan igen.",
      "person": "Kör uppdraget igen när någon kan svara.",
      "environment": "Kontrollera det anslutna systemet eller tjänsten och kör sedan uppdraget igen.",
      "missionDesign": "Kontrollera uppdragets inställningar och gränser och kör det sedan igen.",
      "platform": "Kör uppdraget igen. Om det händer igen, kontakta din administratör.",
      "unknown": "Kör uppdraget igen. Om det händer igen, kontakta din administratör.",
      "noAnswer": "Kör uppdraget igen när någon kan svara."
    },
    "missingItem": {
      "criteria": "alla framgångskriterier uppfyllda",
      "resourceData": "uppgifter från de anslutna systemen",
      "personAnswer": "ett svar från en person",
      "stepOutputs": "varje stegs resultat",
      "time": "tid att slutföra",
      "room": "utrymme för modellen att läsa allt"
    },
    "cutNote": {
      "title": "Vissa värden i den här körningen förkortades för att rymmas inom dess gränser.",
      "kind": {
        "delegationHandoff": "Resultat som lämnades från en agent till en annan förkortades eller utelämnades.",
        "taskPromptValue": "Vissa tidigare resultat förkortades för att rymmas i modellen.",
        "contextShortened": "Tidigare meddelanden i konversationen förkortades för att rymmas i modellen.",
        "runStateText": "Resultat av tidigare mål och insamlade svar förkortades.",
        "verdictEvidence": "Beviset som citerades i svarskontrollen förkortades.",
        "hydratedRows": "Ett steg fick bara de första raderna i en stor tabell.",
        "schemaTables": "Vissa tabeller eller datamängder i ett anslutet system utelämnades från det som visades för modellen.",
        "runLimitBounded": "En gräns som angavs i uppdraget var högre än sitt maximum, så körningen använde maximum."
      },
      "storage": "Om arbetsytelagring slås på på värden behålls värdena hela."
    },
    "code": {
      "CONTEXT_LIMIT": {
        "title": "Texten som skickades till modellen var för lång, även efter förkortning",
        "next": "Korta ner indata eller dela upp uppgiften i mindre delar och kör den sedan igen."
      },
      "RUN_TIME_LIMIT": {
        "title": "Tidsgränsen nåddes",
        "next": "En organisationsadministratör kan höja körningens tidsgräns under Inställningar, inom det intervall Agion tillåter, eller så kan uppgiften avgränsas så att den blir klar snabbare."
      },
      "SOURCE_READ_INCOMPLETE": {
        "title": "Ett anslutet system slutade skicka data innan läsningen var klar",
        "next": "Kontrollera det anslutna systemet och kör sedan uppdraget igen."
      },
      "PROVIDER_QUOTA_EXHAUSTED": {
        "next": "En organisationsadministratör kan höja kvoten hos modelleverantören eller välja en annan modell."
      }
    },
    "codeLabel": "Kod: {{code}}",
    "reason": {
      "hostStoreFull": {
        "title": "Värdens lagring för resultat var full med data från körningar som fortfarande pågick",
        "next": "En ägare eller administratör i organisationen kan kontrollera storleksgränsen för sparade resultat på värdens sida och sedan köra uppdraget igen."
      }
    }
  }
}
